@if (postInfo()) {
    <div class="o-grid__row">
        <div class="post note">
            <time class="post-date" [dateTime]="postTime()">
                {{ postInfo().occurredOn | dateFormat: DateFormat.dateTime12 : 'local' | uppercase }}
            </time>
            <p>{{ getPostMessage() }}</p>
        </div>
    </div>
}
